import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-6 bg-gray-50 border-t border-gray-100" data-id="element-58">
      <div className="max-w-3xl mx-auto text-center" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-60">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-gray-900 mb-4" data-id="element-61">
            Deja de perder tiempo con compradores que no sirven
          </h2>
          <p className="text-lg text-gray-500 mb-10" data-id="element-62">
            Agenda un diagnóstico gratuito y te mostramos cómo vender mejor.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-63">
            <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-brand-600 hover:bg-brand-700 text-white px-8 py-4 rounded-full font-medium transition-all shadow-sm hover:shadow-md text-lg" data-id="element-64">
              Agendar diagnóstico gratuito
              <ArrowRight size={18} data-id="element-65" />
            </button>
            <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-500 border border-gray-200 px-8 py-4 rounded-full font-medium transition-all text-base" data-id="element-66">
              <MessageCircle size={18} className="text-gray-400" data-id="element-67" />
              Evaluar mi propiedad
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}